import { Box } from '@mui/material';
import React from 'react';
import Header from '../header';
import styles from './page-header-tabs.module.scss';

interface Props {
    headerLocalizationId: string;
    children: React.ReactNode;
    actions?: React.ReactNode;
    loading?: boolean;
}

export default function PageHeaderTabs({ headerLocalizationId, children, actions, loading }: Props) {
    return (
        <Box className={styles.pageHeader}>
            <div className={styles.pageHeaderContainer}>
                <div className={styles.container}>
                    <div className={styles.containerItem}>
                        <div className={styles.headerRow}>
                            <div className={styles.title}>
                                <Header headerLocalizationId={headerLocalizationId} loading={loading} />
                            </div>
                            <div className={styles.actions}>
                                {actions ? actions : <></>}
                            </div>
                        </div>
                        <Box className={styles.tabsWrapper}>
                            {children}
                        </Box>
                    </div>
                </div>
            </div>
        </Box>
    );
}
